<template>
  <div>
    <v-text-field
      readonly
      class="default-input"
      outline
      name="startTime"
      :value="value"
      single-line
      @click="show = true"
      :hide-details="$attrs['hide-details'] || true"
      @click:clear="$emit('onChange', '')"
      v-bind="$attrs"
    ></v-text-field>
    <v-dialog v-model="show" scrollable max-width="500px">
      <v-card>
        <v-card-text>
          <VueCtkDateTimePicker
            :color="$vuetify.theme.primary"
            :value="value"
            v-bind="$attrs"
            :no-value-to-custom-elem="true"
            @input="$emit('onChange', $event)"
            inline
          >
          </VueCtkDateTimePicker>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn @click="show = false" color="primary">{{ $t('submit') }}</v-btn>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
export default {
  props: ['value'],
  components: {
    VueCtkDateTimePicker
  },
  data() {
    return {
      show: false
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/elements/CustomTimepicker2.vue